import { motion } from "framer-motion";
import { sparklePath } from "./hearts";

const lidVariants = {
  idle: { x: "0%", y: "0%", rotate: 0, opacity: 1, transition: { type: "spring", stiffness: 260, damping: 20 } },
  open: { x: "-12%", y: "-150%", rotate: -16, opacity: 1, transition: { type: "spring", stiffness: 240, damping: 13 } },
  finale: { x: "-55%", y: "-620%", rotate: -48, opacity: 0, transition: { duration: 1.1, ease: [0.3, 0.1, 0.3, 1] } },
};

const baseVariants = {
  idle: { y: "0%", opacity: 1, scale: 1 },
  open: { y: "0%", opacity: 1, scale: 1 },
  finale: { y: "40%", opacity: 0, scale: 0.9, transition: { delay: 0.45, duration: 0.6, ease: [0.4, 0, 0.2, 1] } },
};

const sparkles = [
  { left: "-16%", top: "26%", size: 16, delay: "0s" },
  { left: "106%", top: "34%", size: 12, delay: "0.9s" },
  { left: "-8%", top: "74%", size: 10, delay: "1.7s" },
  { left: "102%", top: "80%", size: 15, delay: "0.4s" },
  { left: "14%", top: "-4%", size: 11, delay: "1.3s" },
  { left: "88%", top: "4%", size: 13, delay: "2.1s" },
];

function Bow() {
  return (
    <svg className="gift-bow" viewBox="0 0 120 64" aria-hidden="true">
      <path d="M57 49C53 55 47 60 41 64H51C55 60 58 56 60 52Z" fill="#f3dde2" />
      <path d="M63 49C67 55 73 60 79 64H69C65 60 62 56 60 52Z" fill="#f3dde2" />
      <path d="M60 46C50 26 26 6 12 14 0 22 6 44 26 48 38 50 50 49 60 46Z" fill="#fffaf6" stroke="#e5adbc" strokeWidth="1.3" />
      <path d="M58 45C46 32 30 22 22 26 15 30 18 40 30 43 40 45 50 46 58 45Z" fill="#f6e1e5" />
      <path d="M60 46C70 26 94 6 108 14 120 22 114 44 94 48 82 50 70 49 60 46Z" fill="#fffaf6" stroke="#e5adbc" strokeWidth="1.3" />
      <path d="M62 45C74 32 90 22 98 26 105 30 102 40 90 43 80 45 70 46 62 45Z" fill="#f6e1e5" />
      <rect x="51" y="37" width="18" height="16" rx="7" fill="#fffaf6" stroke="#e5adbc" strokeWidth="1.3" />
    </svg>
  );
}

export default function GiftBox({ mode, onOpen, isReady, label }) {
  const isIdle = mode === "idle";

  return (
    <motion.button
      type="button"
      className={`gift gift--${mode}`}
      onClick={onOpen}
      aria-label={label}
      aria-disabled={!isIdle || !isReady}
      whileTap={isIdle ? { scale: 0.94 } : undefined}
    >
      <div className="gift-shadow" />
      <div className="gift-float">
        <motion.div
          className="gift-light"
          initial={false}
          animate={isIdle ? { opacity: 0, scale: 0.5 } : { opacity: 1, scale: 1 }}
          transition={{ duration: isIdle ? 0.4 : 0.7, ease: "easeOut" }}
        >
          <div className="gift-rays" />
        </motion.div>
        <motion.div className="gift-base" variants={baseVariants} initial={false} animate={mode}>
          <div className="gift-ribbon" />
          <motion.div
            className="gift-mouth"
            initial={false}
            animate={{ opacity: isIdle ? 0 : 1 }}
            transition={{ duration: 0.25 }}
          />
        </motion.div>
        <motion.div className="gift-lid" variants={lidVariants} initial={false} animate={mode}>
          <div className="gift-ribbon" />
          <Bow />
        </motion.div>
      </div>
      {sparkles.map((sparkle) => (
        <svg
          key={`${sparkle.left}-${sparkle.top}`}
          className="gift-sparkle"
          viewBox="0 0 24 24"
          style={{ left: sparkle.left, top: sparkle.top, width: sparkle.size, height: sparkle.size, animationDelay: sparkle.delay }}
          aria-hidden="true"
        >
          <path d={sparklePath} fill="currentColor" />
        </svg>
      ))}
    </motion.button>
  );
}
